import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'
import { Tabs, Tab } from 'material-ui/Tabs'
import Associations from '../associations'

const questionFields = [
  { name: 'Question', prop: 'question_id', type: 'autocomplete', references: 'admin/questions', referenceProp: 'question' }
]

const timerFields = [
  { name: 'Timer', prop: 'timer_type_id', type: 'autocomplete', references: 'admin/timer_types', referenceProp: 'timer_type' }
]

const associationColumns = [
  { name: 'ID', prop: 'id' },
  { name: 'Question', prop: 'question' }
]

const timerColumns = [
  { name: 'ID', prop: 'id' },
  { name: 'Timer Type', prop: 'timer_type' }
]

const EditProgram = (props) => {
  return (
    <Tabs>
      <Tab label='Edit Program'>
        <Edit
// @ts-ignore
          title='Edit Program'
          fields={fields}
          apiPath={`admin/programs/${props.params.programId}`}
          successRedirectPath='/write-now/programs'
          buildMenuItems={menuItems}
        />
      </Tab>
      <Tab label='Manage Questions'>
        <Associations
// @ts-ignore
          title='Manage Questions'
          fields={questionFields}
          columns={associationColumns}
          baseRecord={{ program_id: props.params.programId }}
          joinApiPath='admin/program_questions'
          associationApiPath='admin/questions'
          joinApiQuery={{ 'filters[program_id]': props.params.programId }}
          associationIdField='question_id'
          queryOrder={[{ column: 'id', direction: 'asc' }]}
        />
      </Tab>
      <Tab label='Manage Timers'>
        <Associations
// @ts-ignore
          title='Manage Timers'
          fields={timerFields}
          columns={timerColumns}
          baseRecord={{ program_id: props.params.programId }}
          joinApiPath='admin/program_timer_types'
          associationApiPath='admin/timer_types'
          joinApiQuery={{ 'filters[program_id]': props.params.programId }}
          associationIdField='timer_type_id'
          queryOrder={[{ column: 'id', direction: 'asc' }]}
        />
      </Tab>
    </Tabs>
  )
}

export default EditProgram
